import type {
  ProfileDto,
  UpdateProfileRequest,
  ChangePasswordRequest,
} from '../types/profile.types';

import { api } from '@config/apiEndpoints';
import { axiosClient as axios } from 'src/services/axiosClient';

const BASE = `${api.AUTH_BASE_URL}api/v1/my-profile`;

function mapProfile(data: Record<string, unknown>): ProfileDto {
  return {
    sub: (data.sub ?? data.Sub ?? '') as string,
    email: (data.email ?? data.Email ?? '') as string,
    displayName: (data.displayName ?? data.DisplayName ?? '') as string,
    firstName: (data.firstName ?? data.FirstName ?? '') as string,
    middleName: (data.middleName ?? data.MiddleName) as string | undefined,
    lastName: (data.lastName ?? data.LastName ?? '') as string,
    phoneNumber: (data.phoneNumber ?? data.PhoneNumber) as string | undefined,
  };
}

export async function fetchProfile(): Promise<ProfileDto> {
  const response = await axios.get(BASE);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body = response.data as any;
  const data = body?.data ?? body;
  return mapProfile(data as Record<string, unknown>);
}

export async function updateProfile(
  request: UpdateProfileRequest
): Promise<ProfileDto> {
  const response = await axios.put(BASE, {
    FirstName: request.firstName,
    MiddleName: request.middleName ?? null,
    LastName: request.lastName,
    PhoneNumber: request.phoneNumber ?? null,
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body = response.data as any;
  const data = body?.data ?? body;
  return mapProfile(data as Record<string, unknown>);
}

export async function changePassword(
  request: ChangePasswordRequest
): Promise<void> {
  await axios.post(`${BASE}/change-password`, {
    CurrentPassword: request.currentPassword,
    NewPassword: request.newPassword,
  });
}
